/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GdsIss0101Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const gdsIss0101ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false,
  printIsLoading: false
});

export const gdsIss0101FetchGdsIss0101Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsIss0101FetchGdsIss0101Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const gdsIss0101AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const gdsIss0101RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const gdsIss0101SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const gdsIss0101PrintGdsIss0101Loading = (state, { boolean }) => ({
  ...state,
  printIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GdsIss0101Types.GDS_ISS0101_RESET_TIMESTAMP]: gdsIss0101ResetTimestamp,
  [GdsIss0101Types.GDS_ISS0101_FETCH_GDS_ISS0101_LOADING]: gdsIss0101FetchGdsIss0101Loading,
  [GdsIss0101Types.GDS_ISS0101_FETCH_GDS_ISS0101_SUCCESS]: gdsIss0101FetchGdsIss0101Success,
  [GdsIss0101Types.GDS_ISS0101_ADD_SELECTED_DOCUMENTS]: gdsIss0101AddSelectedDocuments,
  [GdsIss0101Types.GDS_ISS0101_REMOVE_SELECTED_DOCUMENTS]: gdsIss0101RemoveSelectedDocuments,
  [GdsIss0101Types.GDS_ISS0101_SET_WORKSPACE_VISIBLE]: gdsIss0101SetWorkspaceVisible,
  [GdsIss0101Types.GDS_ISS0101_PRINT_GDS_ISS0101_LOADING]: gdsIss0101PrintGdsIss0101Loading
});
